<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item :to="{ name: 'Channels' }">Channels</b-breadcrumb-item>
			<b-breadcrumb-item active v-if="!!error" class="text-danger"><i>Error</i></b-breadcrumb-item>
			<b-breadcrumb-item active v-else-if="loading>0" class="text-muted"><i>Loading...</i></b-breadcrumb-item>
			<b-breadcrumb-item active v-else>{{channel&&channel.title}}</b-breadcrumb-item>
		</b-breadcrumb>
		<b-alert :show="!!error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<b-card-group v-if="!error&&channel">
			<b-card no-body>
				<template #header>Details</template>
				<b-list-group flush>
					<b-list-group-item>
						Avatar:
						<span class="float-right">
							<b-avatar size="2em" :src="channel.avatar_url||channel.service_icon_url"></b-avatar>
						</span>
					</b-list-group-item>
					<b-list-group-item>Service: <span class="float-right">{{channel.service_name}}</span></b-list-group-item>
					<b-list-group-item>Channel ID: <span class="float-right text-monospace">{{channel.token}}</span></b-list-group-item>
					<b-list-group-item>Name: <span class="float-right">{{channel.title}}</span></b-list-group-item>
					<b-list-group-item>
						Owner:
						<span class="float-right">
							<a href="#" v-if="channel.user_id" @click.prevent="loginAsUser(channel.user_id)" title="Log in as this user">{{channel.username}}</a>
							<span v-else>{{channel.username}}</span>
						</span>
					</b-list-group-item>
					<b-list-group-item>Status: <span class="float-right">{{channel.status}}</span></b-list-group-item>
					<b-list-group-item>
						Verified:
						<span class="float-right">
							<b-badge :variant="channel.verification_status == 'verified' ? 'success' : 'secondary'">{{channel.verification_status}}</b-badge>
						</span>
					</b-list-group-item>
				</b-list-group>
			</b-card>
		</b-card-group>
		<b-card no-body v-if="channel" class="mt-3">
			<template #header>Emotes <b-badge>{{channel.emotes.length}}</b-badge></template>
			<p class="text-muted mb-0 p-3" v-if="!channel.emotes.length">No emotes synced for this channel yet.</p>
			<b-table v-else small striped :items="channel.emotes" :fields="[{ key: 'image_url', label: 'Original', thStyle: { width: '48px' } },{ key: 'storage_url', label: 'Mirrored', thStyle: { width: '48px' } },{ key: 'label', thStyle: { width: '160px' } },{ key: 'shortcuts', label: 'Aliases', tdClass: 'text-wrap' },{ key: 'is_members', label: 'Members', thStyle: { width: '90px' } }]" style="table-layout: fixed;" class="mb-0">
				<template #cell(image_url)="data">
					<img :src="data.item.image_url" :alt="`${data.item.label} (original)`" style="max-width: 32px; max-height: 32px;" />
				</template>
				<template #cell(storage_url)="data">
					<img :src="data.item.storage_url" :alt="`${data.item.label} (mirrored)`" style="max-width: 32px; max-height: 32px;" />
				</template>
				<template #cell(shortcuts)="data">
					<code v-for="s in data.item.shortcuts" :key="s" class="mr-1">{{s}}</code>
				</template>
				<template #cell(is_members)="data">
					<b-badge v-if="data.item.is_members" variant="info">members</b-badge>
				</template>
			</b-table>
		</b-card>
		<b-card no-body v-if="channel" class="mt-3">
			<template #header>Membership levels <b-badge>{{channel.membershipLevels.length}}</b-badge></template>
			<p class="text-muted mb-0 p-3" v-if="!channel.membershipLevels.length">No membership levels synced for this channel yet.</p>
			<b-table v-else small striped :items="channel.membershipLevels" :fields="['name','position',{ key: 'price', label: 'Price' }]" class="mb-0">
				<template #cell(price)="data">
					{{data.item.value != null ? `${data.item.value} ${data.item.currency||''}` : '-'}}
				</template>
			</b-table>
		</b-card>
	</div>
</template>

<script>
export default {
	name: 'channel',
	data() { return {
		loading: 0,
		error: null,
		channel: null,
	}},
	created() {
		this.loadChannel();
	},
	methods: {
		async loadChannel() {
			try {
				this.loading++;
				this.error = null;
				this.channel = await this.$api.get(`admin/userChannel/${encodeURIComponent(this.$route.params.userId)}/${encodeURIComponent(this.$route.params.serviceId)}/${encodeURIComponent(this.$route.params.token)}/details`);
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		async loginAsUser(userId) {
			const { token } = await this.$api.post(`auth/${encodeURIComponent(userId)}`);
			this.$auth.pushToken(token);
			this.$router.push('/');
		},
	},
};
</script>
